import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UserService {
  public isUnderwriter: boolean = false;

  constructor() {
    try {
      const underwriterParameter = new URLSearchParams(
        "?" + window.location.href.split("?")[1],
      ).get("underwriter");
      this.isUnderwriter = JSON.parse(underwriterParameter);
    } catch (_error) {
      this.isUnderwriter = false;
    }
  }
}
